var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"layoutDefault"}},[_c('div',{attrs:{"id":"layoutDefault_content"}},[_c('main',[_vm._t("default")],2)]),_c('div',{attrs:{"id":"layoutDefault_footer"}},[_c('sbpro-footer',{class:_vm.footerClasses})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }